const datePickerOptions = {
  enableTime: true,
  dateFormat: "DD/MM/YYYY HH:mm",
  placeholder: "dd/mm/yyyy hh:mm",
};

export const uiSchema = t => {
  return {
    alertConfiguration: {
      id: {
        "ui:title": t("SPECIFY_ALERT_EXCLUSION"),
      },
    },
    exclusionReason: {
      id: {
        "ui:title": t("SPECIFY_REASON_ALERT_EXCLUSION"),
      },
    },
    activeFrom: {
      "ui:widget": "date-picker",
      "ui:title": t("DATE_EXCLUDED_FROM"),
      "ui:options": datePickerOptions,
    },

    activeTo: {
      "ui:widget": "date-picker",
      "ui:title": t("DATE_EXCLUDED_TO"),
      "ui:options": datePickerOptions,
    },
  };
};
